import {
  Command,
  Editor,
} from 'ckeditor5';

export default class EditorStateCommand extends Command {
  private everFocused = false;

  get hasEverBeenFocused() {
    return this.everFocused;
  }

  constructor(editor: Editor) {
    super(editor);
    editor.editing.view.document.once('focus', () => {
      this.everFocused = true;
    });
  }

  refresh() {
    this.isEnabled = true;
  }
}
